export type WindowHook = {
  openInNewTab: (url: string) => void;
};

export const useWindow = (): WindowHook => ({
  openInNewTab: (url: string) => {
    window.open(url);
  },
});
